<template>
	<div class="edu-univ-banner-container">
		<img
			class="edu-univ-banner-illust"
			:src="`/images/edu/univ/edu-univ-banner-background${isMobile ? '-m' : ''}.png` | getCdnImageSrc"
			alt=""
		/>
		<GridLayout style="background-color: transparent">
			<c-new-col :col-lg="12">
				<div class="edu-univ-banner-script-container">
					<c-typography class="mb-8" type="headline5" :font-weight="600" color="white">
						{{ univ }} 주최
					</c-typography>
					<c-typography class="mb-20" type="headline1" color="white" :font-weight="600">
						현직자와 5주 직무경험<br v-if="isMobile" />{{
							isMobile ? '전액 무료 직무부트캠프' : ', 전액 무료로 만나는 직무부트캠프'
						}}
					</c-typography>
					<c-typography type="body2" color="white" :font-weight="400">
						본 프로그램은 전액 무료로 제공되며, <br v-if="isMobile" />선발과정을 거쳐 진행됩니다.
					</c-typography>
				</div>
			</c-new-col>
		</GridLayout>
	</div>
</template>

<script>
import GridLayout from '@/components/common/GridLayout.vue';
import { getCdnImageSrc } from '@/utils/util';

export default {
	name: 'EduUnivBanner',
	props: {
		univ: {
			type: String,
			default: '',
		},
	},
	filters: {
		getCdnImageSrc,
	},
	components: { GridLayout },
};
</script>

<style scoped lang="scss">
@import 'resources/assets/scss/base/main';

$banner-height: 300px;
$banner-height-m: 250px;
$sponsor-banner-height: 38px;
$sponsor-banner-height-m: 35px;

.edu-univ-banner {
	&-container {
		position: relative;
		background-color: #71a3de;
		height: 280px;
		margin-bottom: 40px;
		@include mobile {
			height: 443px;
		}
	}
	&-illust {
		position: absolute;
		height: 280px;
		left: 50%;
		transform: translateX(-50%);
		@include pc {
			top: 0;
			right: 0;
		}
		@include mobile {
			bottom: 0;
			height: 443px;
			max-width: 551px;
		}
	}
	&-script {
		&-container {
			position: relative;
			@include pc {
				padding-top: 112px;
				height: 280px;
			}
			@include mobile {
				text-align: center;
				padding-top: 32px;
				height: 251px;
			}
		}
	}
}
</style>
